var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("fluxo"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("fluxo")
            },
          },
        },
        [_c("i", { staticClass: "fa fa-money" }), _vm._v(" Fluxo\n  ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("prorrogado"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("prorrogado")
            },
          },
        },
        [_c("i", { staticClass: "fa fa-money" }), _vm._v(" Prorrogado\n  ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn opcoesFluxoCaixa",
          class: _vm.getClass("lancamentoTesouraria"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("lancamentoTesouraria")
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-money" }),
          _vm._v(" Lançamentos de tesouraria\n  "),
        ]
      ),
      _vm._v(" "),
      _c("transition-group", { attrs: { name: "slide-fade" } }, [
        _vm.isSaldoCompensadoEnabled()
          ? _c(
              "a",
              {
                key: "saldoCompensadoEnabled",
                staticClass: "btn",
                class: _vm.getClass("exibirSaldoCompensado"),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected("exibirSaldoCompensado")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-money" }),
                _vm._v(" Saldo Compensado\n    "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isIgnorarCompensadoEnabled()
          ? _c(
              "a",
              {
                key: "ignorarCompensadoEnabled",
                staticClass: "btn",
                class: _vm.getClass("ignorarCompensado"),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected("ignorarCompensado")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-money" }),
                _vm._v(" Ignorar compensado\n    "),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }